module.exports = __webpack_public_path__ + "img/eye.9150451d.svg";